import { Link } from "components/DesignSystem/Link/Link";
import { OctagonExclamation } from "components/icons/OctagonExclamation";
import { SmallRightArrow } from "components/icons/SmallRightArrow";
import { pluralize } from "utils/pluralize";

type NotRegisteredAlertCardProps = {
  count: number;
  nexusTrackerUrl: string;
};

export const NotRegisteredAlertCard = ({
  count,
  nexusTrackerUrl,
}: NotRegisteredAlertCardProps) => {
  return (
    <div className="t-flex-1 t-rounded-lg t-border t-border-solid t-border-neutral-0 t-bg-upcoming-deadline-gradient t-p-5">
      <div className="t-flex t-gap-2">
        <span className="t-flex t-shrink-0 t-text-red-70">
          <OctagonExclamation />
        </span>
        <div className="t-flex t-flex-col t-gap-2">
          <p className="t-m-0 t-text-subtitle-sm t-text-text-100">
            {pluralize(count, "state", "states")} — not registered
          </p>
          <p className="t-m-0 t-text-body-sm t-text-text-30">
            Nexus established, no application started. You&apos;re liable from
            the day the threshold was crossed.
          </p>
          <Link
            to={nexusTrackerUrl}
            className="t-flex t-w-fit t-items-center t-gap-1 t-text-body-sm !t-text-purple"
          >
            Register now <SmallRightArrow />
          </Link>
        </div>
      </div>
    </div>
  );
};
